import React from 'react';
import { NavLink } from 'react-router-dom';
import './CommissionSectionNav.css';

export default function CommissionSectionNav() {
  return <nav className="commission-section-nav" aria-label="Commission pages">
    <NavLink to="/commissions" end>Summary</NavLink>
    <NavLink to="/commission-control">Admin</NavLink>
  </nav>;
}
